import React from 'react';
import { cnRadiobox as cn } from '../Radiobox';
import './Radiobox-Control.css';
export var RadioboxControl = function (_a) {
    var autoFocus = _a.autoFocus, checked = _a.checked, controlRef = _a.controlRef, disabled = _a.disabled, labelledBy = _a.labelledBy, name = _a.name, onChange = _a.onChange, value = _a.value;
    return (React.createElement("input", { "aria-checked": checked, "aria-labelledby": labelledBy, autoFocus: autoFocus, 
        // Отключаем autoComplete, чтобы в FireFox
        // не сохранялось значение при перезагрузке страницы.
        autoComplete: "off", checked: checked, className: cn('Control'), disabled: disabled, name: name, onChange: onChange, ref: controlRef, type: "radio", value: value }));
};
